<template>
  <div>
    <div class="table-responsive">
      <div class="flex-row align-center justify-between">
        <h5 class="page-title" style="font-weight: 600">Setting News</h5>
        <div class="flex-row">
          <b-btn
            size="sm"
            variant="primary"
            class="btn-group-space"
            @click="view(0)"
            v-b-modal.edit-news
            >Add New Item</b-btn
          >
        </div>
      </div>

      <br />
      <table class="table">
        <thead>
          <tr>
            <th width="80">Sort</th>
            <th>Images</th>
            <th class="title-table">Title</th>
            <th>News Date</th>
            <th>Type</th>
            <th>Published</th>
            <th>Start/Stop Auto Published</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in data" :key="list.id">
            <td>
              <b-form-select
                name
                id
                :value="list.orderNum"
                :sync="true"
                v-on:change="updateSorting($event, list)"
              >
                <option
                  v-for="(ls, index) in orderList"
                  :value="ls"
                  :key="index + 1"
                >
                  {{ index + 1 }}
                </option>
              </b-form-select>
            </td>
            <td>
              <img
                :src="renderImage(list.thumb[0].filename)"
                alt
                class="banner"
              />
            </td>
            <td class="title-table">{{ renderTitle(list.title) }}</td>
            <td>{{ renderDate(list.showDate) }}</td>
            <td>{{ list.type }}</td>
            <td>
              <toggle-button
                :value="list.status.toLowerCase() === 'active'"
                :labels="true"
                @change="(e) => onSetActive(e, list)"
                :disabled="validateDisable(list)"
              />
            </td>
            <td>
              <p class="start_stop_date">
                start: {{ renderDate(list.startDate) }}
              </p>
              <p class="start_stop_date">end: {{ renderDate(list.endDate) }}</p>
            </td>
            <td>
              <b-button-group>
                <b-btn
                  size="sm"
                  variant="outline-primary"
                  @click="view(list.id)"
                  class="mx-1"
                  >Edit</b-btn
                >
                <b-button
                  size="sm"
                  variant="outline-danger"
                  class="btn-group-space"
                  v-on:click="deleteData(list)"
                  >Delete</b-button
                >
              </b-button-group>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="table-pagination">
      <b-pagination
        v-model="paginate.page"
        :total-rows="paginate.totalRow"
        :per-page="paginate.limit"
        v-on:change="onUpdatePaginate"
      ></b-pagination>
      <b-form-select
        class="col-2 mx-2"
        v-model="paginate.limit"
        :options="perPageOptions"
        v-on:change="onUpdateLimit"
      ></b-form-select>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    onSetActive: Function,
    onUpdatePaginate: Function,
    onUpdateLimit: Function,
    onUpdateSort: Function,
    onDeleteNews: Function,
    paginate: {
      type: Object,
      default: () => {
        return {
          limit: 10,
          page: 1,
          totalPage: 1,
          totalRow: 0,
        }
      },
    },
  },
  components: {},
  data: () => ({
    perPageOptions: [
      { value: 10, text: '10 / page' },
      { value: 20, text: '20 / page' },
      { value: 30, text: '30 / page' },
    ],
    orderList: [],
  }),
  methods: {
    view(id) {
      this.$router.push(`/newsandarticles/news/${id}/edit`)
    },
    validateDisable($data) {
      let result = !!$data.startDate && !!$data.endDate
      return result
    },
    updateSorting($newVal, $data) {
      let dataSort = {
        id: $data.id,
        orderNew: $newVal,
        orderOld: $data.orderNum,
      }

      this.onUpdateSort(dataSort)
    },
    renderImage($image) {
      return `${process.env.VUE_APP_WEBSITE_ENDPOINT}${$image}`
    },
    renderDate(date) {
      return date ? format(date, 'YYYY-MM-DD') : ''
    },
    renderTitle($title) {
      return $title.th ? $title.th : $title.en
    },
    deleteData($data) {
      if (confirm('Are you sure?')) {
        this.onDeleteNews($data.id)
      }
    },
  },
  watch: {
    'paginate.totalRow': function (newVal, oldVal) {
      this.orderList = []
      for (let ls = 1; ls <= newVal; ls++) {
        this.orderList.push(ls)
      }
    },
  },
  computed: {
    rows() {
      return this.data.length
    },
  },
}
</script>

<style>
.yellobutton {
  background-color: rgb(0, 204, 0);
  border: 1px solid rgb(0, 204, 0);
}
.btn-group-space.yellobutton:hover {
  background-color: rgb(19, 173, 96);
  border: 1px solid rgb(19, 173, 96);
}
.redbutton {
  background-color: rgb(233, 0, 0);
  border: 1px solid rgb(233, 0, 0);
}
.redbutton:hover {
  background-color: rgb(165, 0, 0);
  border: 1px solid rgb(165, 0, 0);
}
.banner {
  max-width: 200px;
  max-height: 50px;
}
.start_stop_date {
  font-size: 12px;
  margin: 0px;
  color: #000;
}
td {
  vertical-align: middle !important;
  font-size: 14px;
}
#table-pagination {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.btn-group-space {
  margin-left: 5px;
  margin-right: 5px;
  min-width: 80px;
}
.title-table {
  width: 30%;
}
/* th {
  text-align: center;
}
td {
  text-align: center;
} */
</style>
